// Fluxo padrão de mensagens do robô (semeado quando a empresa ainda não tem
// nenhum fluxo configurado). Cópia do seed usado pela tela de Mensagens
// personalizadas — mesmo conteúdo enviado ao backend em chatbot/create.
export const initialConfigs = {
  interval: '00:03',
  intervalMessage: 90000,
  ignoreGroups: true,
  useMenu: true,
};

export const initialValues = [
  {
    Id: 1,
    name: 'Responda para oi, olá',
    text: 'Olá {{nome_cliente}}, {{saudacao}}!{{dividir_texto}}Bem vindo ao nosso restaurante.{{dividir_texto}}\nDigite *Cardápio* ou acesse o _*link* _ do nosso cardápio digital para ver nosso cardápio completo. 👇\n{{link_cardapio}}',
    keywords: '["oi","ola","bom dia","boa tarde","boa noite"]',
    firstContact: 1,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 1,
    isPending: 0,
    isProgress: 0,
    isDelivered: 0,
    isPickUp: 0,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 2,
    name: 'Horário de funcionamento',
    text: 'Nós estamos abertos de *segunda* a *sexta* {{horario_funcionamento}}',
    keywords:
      '["funcionando","atendendo","posso fazer pedido?","aberto","abertos","funciona"]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 1,
    isPending: 0,
    isProgress: 0,
    isDelivered: 0,
    isPickUp: 0,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 3,
    name: 'O que você deseja responder quando o cliente pergunta sobre o cardápio?',
    text: 'Você pode digitar *Cardápio* para ver nossos preços.{{dividir_texto}} Ou você pode dar uma olhada em nosso cardápio entrando no link aqui abaixo 👇 \n{{link_cardapio}}',
    keywords: '["pedido","posso fazer pedido?","novo pedido","menu"]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 0,
    isPending: 0,
    isProgress: 0,
    isDelivered: 0,
    isPickUp: 0,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 4,
    name: 'Resposta para agradecimento',
    text: 'Imagina! 😊',
    keywords: '["obrigado","obrigada","valeu","obgd","obgda"]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 0,
    isPending: 0,
    isProgress: 0,
    isDelivered: 0,
    isPickUp: 0,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 5,
    name: 'Pedido aceito',
    text: 'Olá {{nome_cliente}}!{{dividir_texto}}Nós recebemos o seu pedido e vamos começar a prepará-lo o quanto antes.{{dividir_texto}}Você receberá atualizações do seu pedido por aqui, então não se preocupe 😉',
    keywords: '[]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 1,
    isPending: 1,
    isProgress: 0,
    isDelivered: 0,
    isPickUp: 0,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 6,
    name: 'Pedido em preparação',
    text: 'Olá, {{nome_cliente}}! \nSeu pedido está em preparação e logo sairá para entrega 🤩',
    keywords: '[]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 1,
    isPending: 0,
    isProgress: 1,
    isDelivered: 0,
    isPickUp: 0,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 7,
    name: 'Pedido saiu para entrega',
    text: 'Obaaa! {{nome_cliente}}, seu pedido saiu para entrega! 🤩{{dividir_texto}}Preste atenção para receber o quanto antes.',
    keywords: '[]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 1,
    isPending: 0,
    isProgress: 0,
    isDelivered: 1,
    isPickUp: 0,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 8,
    name: '1 - Informação para cliente vir buscar o pedido',
    text: 'Obaa! {{nome_cliente}}, seu pedido está pronto e está aqui te esperando! 🤩',
    keywords: '[]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 0,
    isPending: 0,
    isProgress: 0,
    isDelivered: 0,
    isPickUp: 1,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 9,
    name: '2 - Informação para cliente vir buscar o pedido',
    text: 'Notícia boaaa 🤩 \n{{nome_cliente}}, seu pedido está pronto, é só vir buscar!',
    keywords: '[]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 0,
    isPending: 0,
    isProgress: 0,
    isDelivered: 0,
    isPickUp: 1,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 10,
    name: 'Mensagem de ajuda ao cliente',
    text: 'Posso te ajudar *nestas situações*:\n\n*-* Pedido\n*-* Cardápio\n*-* Horários de funcionamento\n*-* Nosso endereço\n{{dividir_texto}}\nÉ só *digitar uma destas opções* por aqui mesmo! 😄',
    keywords: '["ajuda","informacoes","informacao","ajudar"]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 0,
    isPending: 0,
    isProgress: 0,
    isDelivered: 0,
    isPickUp: 0,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 11,
    name: 'Mensagem de despedida',
    text: 'Até mais! Esperamos que você volte logo...{{dividir_texto}}\nEstamos te esperando! 😄',
    keywords: '["tchau","ate logo"]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 0,
    isPending: 0,
    isProgress: 0,
    isDelivered: 0,
    isPickUp: 0,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 12,
    name: 'Mensagem para cliente cancelar pedido',
    text: 'Se você acredita que precisa de *ajuda*, entre em contato com o nosso estabelecimento.\n\n📞 {{numero_loja}}',
    keywords: '["cancelar","cancela","estorno"]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 0,
    isPending: 0,
    isProgress: 0,
    isDelivered: 0,
    isPickUp: 0,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 13,
    name: 'Enviar endereço',
    text: 'Um momento enquanto busco nosso(s) *endereço(s)* e *telefone(s)*. 📁{{dividir_texto}}\n*Endereço*:  \n{{endereco_loja}}\n\n*Contato*\n📞 {{numero_loja}}',
    keywords: '["endereco"]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 0,
    isPending: 0,
    isProgress: 0,
    isDelivered: 0,
    isPickUp: 0,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 14,
    name: 'Cardápio WhatsApp',
    text: '📱 Aqui está o nosso cardápio! 👇{{dividir_texto}}{{cardapio}}',
    keywords: '["cardapio","cardapios"]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 0,
    isPending: 0,
    isProgress: 0,
    isDelivered: 0,
    isPickUp: 0,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 15,
    name: 'Mensagem de promoções',
    text: 'Desculpe! infelizmente, não temos nenhuma promoção disponível. 😔 {{dividir_texto}}Porém, você ainda pode dar uma olhada em nosso cardápio digitando *Cardápio* ou através do link 👇 \n{{link_cardapio}}',
    keywords: '[]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 0,
    isPending: 0,
    isProgress: 0,
    isDelivered: 0,
    isPickUp: 0,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 16,
    name: 'Formas de pagamento',
    text: 'Essas são nossas opções de pagamento:\n{{formas_pagamento}}',
    keywords:
      '["pagamento","cartao","pix","credito","debito","vale","alimentacao","vr","va"]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 0,
    isPending: 0,
    isProgress: 0,
    isDelivered: 0,
    isPickUp: 0,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 17,
    name: 'Tipo de pedido',
    text: 'Eu ainda não consigo realizar um pedido, mas que tal ir até *o cardápio digital?*{{dividir_texto}}Lá é muito mais *fácil* e *rápido*, você tem acesso a todas informações do cardápio na palma da sua mão! {{dividir_texto}}E quando finalizar o seu pedido, *eu irei te atualizar sobre tudo que acontece com ele* 😉 {{dividir_texto}}Acesse digitando *Cardápio* ou acesse pelo link 👇\n{{link_cardapio}}',
    keywords:
      '["whats","posso pedir pelo whats?","pedir aqui?","pedir pelo whats"]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 0,
    isPending: 0,
    isProgress: 0,
    isDelivered: 0,
    isPickUp: 0,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 18,
    name: 'Tempo de produção',
    text: 'Infelizmente ainda não temos estimativa de tempo para concluir um pedido',
    keywords: '["demora","tempo"]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 0,
    isPending: 0,
    isProgress: 0,
    isDelivered: 0,
    isPickUp: 0,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 19,
    name: 'Opções de entrega/retirada',
    text: 'Nossas formas de entrega são as seguintes:\n*-* Entregas 🛵\n*-* Retirada de pedidos no local 🚗\n*-* Consumo no estabelecimento 🍽',
    keywords: '["entregas","comer"]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 0,
    isPending: 0,
    isProgress: 0,
    isDelivered: 0,
    isPickUp: 0,
    isFinished: 0,
    isResume: 0,
    variations: null,
  },
  {
    Id: 20,
    name: 'Resumo do pedido',
    text:
      // Grupo TOPO
      '*🧾 Pedido #{{numero_pedido}}*\n🗓 {{data_pedido}}  ⏰ {{hora_pedido}}\n' +
      '{{#if agendado}}⏳ *Pedido agendado*{{/if}}\n\n' +
      // Grupo CLIENTE
      '*👤 Cliente*\n{{nome_cliente}}\n📞 {{telefone_cliente}}\n' +
      '{{#if entrega}}📍 {{endereco_cliente}}{{/if}}\n' +
      '{{#if retirada}}🏪 Retirada no estabelecimento{{/if}}\n' +
      '{{#if consumo_local}}🍽 Consumo no local{{/if}}\n\n' +
      // Grupo PAGAMENTO
      '*💰 Pagamento*\n{{forma_pagamento_pedido}}\n' +
      '{{#if troco}}💵 Troco para: {{troco_para}}{{/if}}\n\n' +
      // Grupo VALORES
      '*💲 Valores*\nProdutos: {{subtotal_pedido}}\n' +
      '{{#if taxa_entrega}}Entrega: {{taxa_entrega}}{{/if}}\n' +
      '*Total: {{total_pedido}}*\n\n' +
      // Grupo ITENS
      '*📝 Itens do pedido*\n' +
      '-----------------------------------\n' +
      '{{produtos_pedido}}\n' +
      '-----------------------------------\n\n' +
      // Grupo RODAPÉ
      '`Data envio: {{data_envio}}`',
    keywords: '[]',
    firstContact: 0,
    linkedMessage: null,
    createdAt: '2023-08-09T14:03:30.000Z',
    Ativo: 1,
    isFavorite: 1,
    isPending: 0,
    isProgress: 0,
    isDelivered: 0,
    isPickUp: 0,
    isFinished: 0,
    isResume: 1,
    variations: JSON.stringify({
      item:
        '*{{quantidade}}x {{descricao}}*{{tamanho}}{{borda}}\n' +
        '{{precoUnitario}} = {{subtotal}}' +
        '{{sabores}}{{adicionais}}{{montagens}}{{observacao}}',
      separadorItens: '\n-----------------------------------\n',
      tamanho: ' {{descricao}}',
      borda: ' (`Borda {{descricao}}`)',
      sabor: '\n`+Sabor: {{rotulo}}`',
      adicional: '\n`{{quantidade}}x Extra {{rotulo}}`',
      montagem: '\n`{{quantidade}}x Adicional {{rotulo}}`',
      observacao: '\n_{{texto}}_',
      endereco: '{{logradouro}} {{numero}}{{complemento}}{{bairro}}',
      enderecoSemCadastro: '{{texto}}',
      enderecoSemDados: 'Não informado',
      tiposEntrega: {
        EN: 'Entrega no endereço',
        RE: 'Retirar no estabelecimento',
        LOCAL: 'Consumo no local',
        AG: 'Agendado (entrega)',
        AGRE: 'Agendado (retirada)',
      },
      formasPagamento: {
        DINHEIRO: 'Dinheiro',
        CARTAO: 'Cartão',
        CREDITO: 'Cartão de crédito',
        DEBITO: 'Cartão de débito',
        PIX: 'PIX',
        VR: 'Vale Refeição',
        VA: 'Vale Alimentação',
      },
      linhaTroco: 'Troco para: {{valorTroco}}',
      sections: {
        topo: '*🧾 Pedido #{{numero_pedido}}*\n🗓 {{data_pedido}}  ⏰ {{hora_pedido}}',
        agendado: '⏳ *Pedido agendado*',
        cliente: '*👤 Cliente*\n{{nome_cliente}}\n📞 {{telefone_cliente}}',
        entrega: '📍 {{endereco_cliente}}',
        retirada: '🏪 Retirada no estabelecimento',
        consumo_local: '🍽 Consumo no local',
        pagamento: '*💰 Pagamento*\n{{forma_pagamento_pedido}}',
        troco: '💵 Troco para: {{troco_para}}',
        subtotal: '*💲 Valores*\nProdutos: {{subtotal_pedido}}',
        taxa_entrega: 'Entrega: {{taxa_entrega}}',
        total: '*Total: {{total_pedido}}*',
        itens:
          '*📝 Itens do pedido*\n-----------------------------------\n{{produtos_pedido}}\n-----------------------------------',
        rodape: '`Data envio: {{data_envio}}`',
      },
    }),
  },
];
